
import JigTooltip from '@/components/input/JigTooltip.vue'
import { getGenerateJigActionState } from '@/services/generate-jig/generate-jig.utils'
import { LibraryEntry } from '@/store/modules/teamlibrary/types'
import { Namespace } from '@/store/types'
import IconBin from '@svg/IconBin.svg'
import IconMore from '@svg/IconMore.svg'
import IconCompress from '@svg/Icon_Compress.svg'
import IconImage from '@svg/Icon_Image.svg'
import IconSpark from '@svg/Icon_Spark.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  components: {
    IconBin,
    IconCompress,
    IconImage,
    IconMore,
    IconSpark,
    JigTooltip,
  },
})
export default class MoreModelActionsVue extends Vue {
  @Getter('isJigSparkOptIn', { namespace: Namespace.App })
  public isJigSparkOptIn!: boolean

  @Getter('isGlobalAIOptOut', { namespace: Namespace.App })
  public isGlobalAIOptOut!: boolean

  @Prop({ type: String, default: '' })
  public customClass!: string

  @Prop({ type: Boolean, default: false })
  public hasThumbnailCustomType!: boolean

  @Prop({ type: String, default: '' })
  public thumbnailURLMapCustomType!: string

  @Prop({ type: Object, required: true })
  public libraryEntry!: LibraryEntry

  @Prop({ type: Boolean, default: false })
  public canGenerateJig!: boolean

  protected mounted() {}

  private get generateJigActionState() {
    return getGenerateJigActionState({
      isJigSparkOptIn: this.isJigSparkOptIn,
      isGlobalAIOptOut: this.isGlobalAIOptOut,
      canGenerateJig: this.canGenerateJig,
    })
  }

  private openGenerateJig() {
    if (this.generateJigActionState.isDisabled) {
      return
    }

    this.$emit('on-generate-jig-clicked')
  }

  private uploadThumbnail() {
    this.$emit('on-upload-clicked')
  }

  private deleteModel() {
    this.$emit('on-delete-clicked')
  }
}
